import React from "react";
import Shortcuts from "../../../../Shortcuts";
import { jsx as _jsx } from "react/jsx-runtime";
export default function ShortcutAdornment(_ref) {
  var keys = _ref.keys,
    combineKeys = _ref.combineKeys,
    color = _ref.color,
    variant = _ref.variant;
  return /*#__PURE__*/_jsx(Shortcuts, {
    keys: keys,
    combineKeys: combineKeys,
    color: color,
    variant: variant
  });
}